import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import * as HighCharts from 'highcharts';
import { setTimeout } from 'timers';
export class Chart {

  type: string;
  title: string;
  subtitle: string;
  categories: string[];
  yAxis: {};
  series: {}[];
 
  constructor(chart) {
    this.type = chart.type;
    this.title = chart.title;
    this.subtitle = chart.subtitle;
    this.categories = chart.categories;
    this.yAxis = chart.yAxis;
    this.series = chart.series;
  }

}

/**
 * Generated class for the HighchartGraphComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'highchart-graph',
  templateUrl: 'highchart-graph.html'
})
export class HighchartGraphComponent implements OnInit, AfterViewInit {

  @Input() chart: Chart;
  chartId: string;

  constructor() {
    console.log('Hello HighchartGraphComponent Component');
  }

  ngOnInit() {
    this.chartId = 'container-' + Math.random().toString(36).slice(-8);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      HighCharts.chart(this.chartId, {
        chart: {
          type: this.chart.type
        },
        title: {
          text: this.chart.title
        },
        subtitle: {
          text: this.chart.subtitle
        },
        xAxis: {
          categories: this.chart.categories
        },
        // 
        yAxis: this.chart.yAxis,
        series: this.chart.series
      });
    }, 500)
  }

}



// WEBPACK FOOTER //
// ./src/components/highchart-graph/highchart-graph.ts